import type { ReactNode } from 'react';

/**
 * A compact row of measurements inside a Section of the SSH environment page
 * (CO-91): a label, the value and one quieter line. The section is already
 * the frame, so these are not tiles (styles/ssh-environment.css).
 */
export function SshStats({ children, testId }: { children: ReactNode; testId?: string }) {
  return (
    <dl className="ssh-stats" data-testid={testId}>
      {children}
    </dl>
  );
}

export function SshStat({ label, value, detail }: { label: ReactNode; value: ReactNode; detail?: ReactNode }) {
  return (
    <div className="ssh-stats__item">
      <dt className="ssh-stats__label">{label}</dt>
      <dd className="ssh-stats__value">{value}</dd>
      {detail ? <dd className="ssh-stats__detail">{detail}</dd> : null}
    </div>
  );
}
